/**
 * Map legend manager — swaps the legend content to match what's currently
 * being highlighted on the map.
 *
 * Three render modes:
 *   - `setLegend(title, items)`     classic list (color swatch + label)
 *   - `setBivariateLegend(...)`     3x3 (or NxN) grid for bivariate maps
 *   - `resetLegend()` / `hideLegend()`  clear / hide
 */

function el() { return document.getElementById('legend'); }

function renderList(title, items) {
  const host = el();
  if (!host) return;
  host.innerHTML = `
    <h5>${escape(title)}</h5>
    ${items.map(it => `
      <div class="leg-row">
        <div class="leg-swatch" style="background:${it.color}${it.dashed ? ';outline:1px dashed rgba(255,245,230,.18);outline-offset:-1px' : ''}"></div>
        ${escape(it.label)}
      </div>
    `).join('')}
  `;
  host.classList.add('vis');
}

/**
 * Render a bivariate legend — palette is a 2-D array (rows = column-A bins
 * low→high, cols = column-B bins low→high). Labels appear as axis chevrons.
 */
function renderBivariate(title, palette, labelA, labelB) {
  const host = el();
  if (!host) return;
  const rows = palette.length;
  const cols = palette[0]?.length || 0;
  if (!rows || !cols) { host.classList.remove('vis'); return; }

  // Build the grid bottom-up so "low A" sits at the bottom (cartographic norm).
  const cells = [];
  for (let r = rows - 1; r >= 0; r--) {
    for (let c = 0; c < cols; c++) {
      cells.push(`<div class="bv-cell" style="background:${palette[r][c]}"></div>`);
    }
  }

  host.innerHTML = `
    <h5>${escape(title)}</h5>
    <div class="bv-wrap">
      <div class="bv-axis-y">${escape(labelA || '')} →</div>
      <div class="bv-grid" style="grid-template-columns:repeat(${cols},14px)">${cells.join('')}</div>
      <div class="bv-axis-x">${escape(labelB || '')} →</div>
    </div>
    <style>
      .bv-wrap{display:grid;grid-template-columns:auto auto;grid-template-rows:auto auto;column-gap:6px;row-gap:4px;align-items:end;margin-top:4px}
      .bv-axis-y{grid-column:1;grid-row:1;writing-mode:vertical-rl;transform:rotate(180deg);font-size:9.5px;color:var(--text3);font-family:var(--font-display);font-style:italic;letter-spacing:0.04em;align-self:end}
      .bv-grid{grid-column:2;grid-row:1;display:grid;grid-auto-rows:14px;gap:1px}
      .bv-cell{width:14px;height:14px}
      .bv-axis-x{grid-column:2;grid-row:2;font-size:9.5px;color:var(--text3);font-family:var(--font-display);font-style:italic;letter-spacing:0.04em;text-align:left}
    </style>
  `;
  host.classList.add('vis');
}

export function setLegend(title, items)                    { renderList(title, items); }
export function setBivariateLegend(title, palette, a, b)   { renderBivariate(title, palette, a, b); }
export function resetLegend()                              { hideLegend(); }
export function hideLegend()                               { el()?.classList.remove('vis'); }

function escape(s) {
  return String(s ?? '').replace(/[&<>"]/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]));
}
